<template>
  <div
    :id="`ss-f-${slug}`"
    class="ss-fld"
    :class="{ 'is-changed': isChanged, 'is-bad': error }"
    :data-path="path"
  >
    <label v-if="label" class="ss-lbl" :for="`ss-i-${slug}`">{{ label }}</label>
    <div class="ss-frow">
      <div class="ss-stp">
        <button
          type="button"
          class="ss-stp__b"
          :aria-label="$t('settings_shell.decrease', { name: name })"
          @click="step(-1)"
        >
          <v-icon size="16">mdi-minus</v-icon>
        </button>
        <input
          :id="`ss-i-${slug}`"
          class="ss-stp__i"
          inputmode="numeric"
          autocomplete="off"
          :value="value"
          :aria-label="name"
          :aria-invalid="error ? 'true' : null"
          :aria-describedby="error ? `ss-m-${slug}` : null"
          @input="onInput"
          @blur="touch"
        />
        <button
          type="button"
          class="ss-stp__b"
          :aria-label="$t('settings_shell.increase', { name: name })"
          @click="step(1)"
        >
          <v-icon size="16">mdi-plus</v-icon>
        </button>
      </div>
      <span v-if="unit" class="ss-unit">{{ unit }}</span>
    </div>
    <span v-if="error" :id="`ss-m-${slug}`" class="ui-err" role="alert">{{ error }}</span>
  </div>
</template>

<script>
import hasSettingsField from "./hasSettingsField";

/** Brojač (− / unos / +) za dane, minute i sekunde. Prazno ili neispravno polje + počinje od donje granice. */
export default {
  name: "SetStepper",
  mixins: [hasSettingsField],
  props: {
    label: { type: String, default: "" },
    aria: { type: String, default: "" },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 60 },
    unit: { type: String, default: "" },
  },
  computed: {
    name() {
      return this.aria || this.label;
    },
  },
  methods: {
    step(delta) {
      const current = String(this.value == null ? "" : this.value).trim();
      const base = /^\d+$/.test(current) ? Number(current) : delta > 0 ? this.min - 1 : this.min + 1;
      this.write(Math.max(this.min, Math.min(this.max, base + delta)));
    },
    onInput(event) {
      const text = event.target.value.trim();
      this.write(/^\d+$/.test(text) ? Number(text) : text);
    },
  },
};
</script>
